import type { ConfiguratorPool } from './configuratorPool.model'
import { z } from 'zod'
import { directusImageDtoSchema, transformDirectusImageDtoToDirectusImage } from '@/models/directus/directusImageDto.model'
import { configuratorPoolColorDtoSchema, transformConfiguratorPoolColorDtoToConfiguratorPoolColor } from './configuratorPoolColorDto.model'
import { configuratorPoolLineDtoSchema, transformConfiguratorPoolLineDtoToConfiguratorPoolLine } from './configuratorPoolLineDto.model'
import { configuratorPoolSizeDtoSchema, transformConfiguratorPoolSizeDtoToConfiguratorPoolSize } from './configuratorPoolSizeDto.model'
import { configuratorPoolStairDtoSchema, transformConfiguratorPoolStairDtoToConfiguratorPoolStair } from './configuratorPoolStairDto.model'

export const configuratorPoolDtoSchema = z.object({
  id: z.number(),
  color: configuratorPoolColorDtoSchema,
  size: configuratorPoolSizeDtoSchema,
  stair: configuratorPoolStairDtoSchema,
  pool_line: configuratorPoolLineDtoSchema,
  pool_image: directusImageDtoSchema,
  pool_image_empty: directusImageDtoSchema,
  pool_image_deck: directusImageDtoSchema,
  pool_image_night: directusImageDtoSchema,
})

export type ConfiguratorPoolDto = z.infer<typeof configuratorPoolDtoSchema>

export function transformConfiguratorPoolDtoToConfiguratorPool(
  configuratorPoolDto: ConfiguratorPoolDto,
): ConfiguratorPool {
  return {
    id: configuratorPoolDto.id,
    color: transformConfiguratorPoolColorDtoToConfiguratorPoolColor(configuratorPoolDto.color),
    size: transformConfiguratorPoolSizeDtoToConfiguratorPoolSize(configuratorPoolDto.size),
    stair: transformConfiguratorPoolStairDtoToConfiguratorPoolStair(configuratorPoolDto.stair),
    poolLine: transformConfiguratorPoolLineDtoToConfiguratorPoolLine(configuratorPoolDto.pool_line),
    poolImage: transformDirectusImageDtoToDirectusImage(configuratorPoolDto.pool_image),
    poolImageEmpty: transformDirectusImageDtoToDirectusImage(configuratorPoolDto.pool_image_empty),
    poolImageDeck: transformDirectusImageDtoToDirectusImage(configuratorPoolDto.pool_image_deck),
    poolImageNight: transformDirectusImageDtoToDirectusImage(configuratorPoolDto.pool_image_night),
  }
}
